import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class WatchpostBurned1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WATCHPOST_BURNED1;
}

export default WatchpostBurned1PoiTileEntity;
